import React, { useEffect } from 'react';

import {
    Button,
    Box,
    Typography,
} from "@mui/material";

import PublishIcon from '@mui/icons-material/Publish';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

import SelectionButton from './SelectionButton';

const AddStudentsMethodPicker = ({ addMethod, setAddMethod, setActiveStep, triggerFileInput }) => {

    const handleNext = () => {
        if (addMethod === 'upload') {
            triggerFileInput();
            return;
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    useEffect(() => {
        if (addMethod === 'later') {
            handleNext();
        }
    }, [addMethod]);

    const handleAddLater = () => {
        if (addMethod === 'later') {
            handleNext();
        } else {
            setAddMethod('later');
        }
    }

    return (
        <Box sx={{ textAlign: 'center', p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>Add Students</Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 3, pl: '100px', pr: '100px' }}>
                Add students to a class by either uploading a list of students or adding them manually.
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-evenly', mb: 3, mt: 6 }}>
                <SelectionButton
                    selected={addMethod === 'upload'}
                    icon={PublishIcon}
                    title="Upload List"
                    description="Upload a list of students in an Excel sheet or similar."
                    onSelect={() => setAddMethod('upload')}
                />
                <SelectionButton
                    selected={addMethod === 'manual'}
                    icon={PersonAddIcon}
                    title="Add Manually"
                    description="Add students manually. Best for 1–2 students."
                    onSelect={() => setAddMethod('manual')}
                />
            </Box>
            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleNext}
                disabled={addMethod !== 'manual' && addMethod !== 'upload'}
            >
              Continue
            </Button>
            <Box>
                <Button
                    variant="text"
                    onClick={handleAddLater}
                    sx={{ color: 'text.secondary' }}
                >add later</Button>
            </Box>
        </Box>
    );
};

export default AddStudentsMethodPicker;
